// @flow
import React, {Component} from 'react';
import styled from 'styled-components';
import {
  Icon,
  IconLookup,
} from 'trustar-2.0/components';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';

// Types
type NumberPickerProps = {
  number: number,
  minimum?: number,
  incrementBy?: number,
  onUpdate?: Function,
  theme: ThemeType,
};

type StateProps = {
  number?: number,
};

const initialValues = {
  number: 0,
  minimum: 0,
  incrementBy: 1,
  theme: DefaultTheme,
};

// Style
const StyledNumberPicker = styled.div`
  width: 4rem;
  display: flex;
  border: 1px solid ${({theme}) => theme.ThemeColors.BLACK.hex};
  justify-content: space-between;
  align-items: center;

  > span {
    text-align: center;
    width: 100%;
    padding: 0 0.25rem;
    cursor: initial;
  }

.arrows {
  display: inline-flex;
  flex-direction: column;
  height: 100%;

  span {
    height: 50%
    padding: 0 0.25rem 0 0.25rem;
    cursor: pointer;
  :hover {
      background-color: ${({theme}) => theme.ThemeColors.BLACK.X100};
    }
  }
}
`;

export class NumberPicker extends Component {
  props: NumberPickerProps;
  state: StateProps;
  static defaultProps = initialValues;
  state = {
    number: this.props.number
  };

  render() {
    return (
      <StyledNumberPicker>
        <span>{this.state.number}</span>
        <div className={'arrows'}>
          <span onClick={this.increment}><Icon icon={IconLookup.CHEVRON_UP} /></span>
          <span onClick={this.decrement}><Icon icon={IconLookup.CHEVRON_DOWN} /></span>
        </div>
      </StyledNumberPicker>
    );
  }

  // ----Methods----
  increment = () => {
    const number = this.state.number + this.props.incrementBy;

    this.setState(() => ({number}));

    if (this.props.onUpdate) {
      this.props.onUpdate(number);
    }
  };
  decrement = () => {
    // $FlowIgnore: Fix later, stupid proptypes
    const number = this.state.number - this.props.incrementBy;

    this.setState(() => ({number}));

    if (this.props.onUpdate) {
      this.props.onUpdate(number);
    }
  };

}

// Logic & Helper Components
//
// $("#myeditablediv").keypress(function(e) {
//   if (isNaN(String.fromCharCode(e.which))) e.preventDefault();
// });



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/NumberPicker.js